import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHead } from "@/components/Bits";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const ACTION_TINT = {
  invoice_value_changed: "bg-rose-50 text-rose-700",
  job_status_changed: "bg-blue-50 text-blue-700",
  consumption_logged: "bg-amber-50 text-amber-700",
  stock_restocked: "bg-emerald-50 text-emerald-700",
  stock_corrected: "bg-violet-50 text-violet-700",
  quote_converted: "bg-crimson-50 text-crimson-700",
  subscription_changed: "bg-slate-100 text-slate-700",
};

export default function Audit() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/audit").then(({ data }) => setRows(data));
  }, []);

  return (
    <div>
      <PageHead
        title="Audit Log"
        subtitle={
          user.role === "network_admin"
            ? "Financial and stock changes across all studios"
            : `Financial and stock changes · ${user.studio_name}`
        }
      />
      <Card className="border-brand-line shadow-none">
        <CardContent className="overflow-x-auto p-0">
          <Table data-testid="audit-table">
            <TableHeader>
              <TableRow>
                <TableHead>When</TableHead>
                <TableHead>Action</TableHead>
                {user.role === "network_admin" && <TableHead>Studio</TableHead>}
                <TableHead>User</TableHead>
                <TableHead>Old value</TableHead>
                <TableHead>New value</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} className="py-12 text-center text-slate-500">
                    No audited changes yet.
                  </TableCell>
                </TableRow>
              )}
              {rows.map((r) => (
                <TableRow key={r.id} className="hover:bg-brand-tint/60">
                  <TableCell className="whitespace-nowrap text-slate-500">
                    {fmtDate(r.timestamp)}
                  </TableCell>
                  <TableCell>
                    <Badge className={`border-0 ${ACTION_TINT[r.action] || "bg-slate-100 text-slate-700"}`}>
                      {r.action.replace(/_/g, " ")}
                    </Badge>
                  </TableCell>
                  {user.role === "network_admin" && (
                    <TableCell className="text-slate-500">{r.studio_name || "—"}</TableCell>
                  )}
                  <TableCell className="font-medium">{r.user_name || "—"}</TableCell>
                  <TableCell className="max-w-xs truncate text-slate-500">{r.old_value || "—"}</TableCell>
                  <TableCell className="max-w-xs truncate text-slate-700">{r.new_value || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
